import { connect } from 'react-redux';

import { getUpdatingSegment } from '../../../reducers/analyticsApp';
import { addSegmentStep, changeSegmentStepPosition } from '../../../actions/segment';
import CompoundUpdateStepContainer from '../../../components/compound/update/StepContainer';

const mapStateToProps = (state) => ({
  steps: getUpdatingSegment(state).steps,
});

const mapDispatchToProps = {
  onAddStep: addSegmentStep,
  onChangeStepPosition: changeSegmentStepPosition,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompoundUpdateStepContainer);
